import gql from "graphql-tag";
import { apolloClient } from "./apollo";
import { PRODUCTION_MODE } from "./globals";
import { sleep } from "./lib/utils";
import store from "./store";

import { gaRouterHook } from "./ga";
import { ErrorType } from "./store/modules/error";
import { clearJwt, getJwt } from "./token";

import meta from "./meta.json";

let isFirstUserFetch = true;

export default function(router) {
  router.beforeEach(async (to, from, next) => {
    if (to.meta && to.meta.title) {
      if (meta[to.meta.title.toLowerCase()]) {
        const top = meta[to.meta.title.toLowerCase()].top;
        store.commit("title", top.title);
        store.commit("metaDescription", top.description);
        store.commit("metaKeyword", top.keyword);
      } else {
        store.commit("title", to.meta.title);
        store.commit("metaDescription", "");
        store.commit("metaKeyword", "");
      }
    } else {
      store.commit("title", "");
      store.commit("metaDescription", "");
      store.commit("metaKeyword", "");
    }
    return next();
  });

  gaRouterHook(router);

  router.beforeEach(async (to, from, next) => {
    if (to.name !== "error") {
      return next();
    }

    const errorCount = store.state.error.stack.length;

    if (errorCount === 0) {
      const sleepTime = 1000;
      await sleep(sleepTime);
      return next({ name: "landing" });
    } else {
      return next();
    }
  });

  router.beforeEach(async (to, from, next) => {
    if (to.meta && to.meta.searchContext) {
      store.commit("searchContext", to.meta.searchContext);
      store.commit("searchContextRouterPath", to.path);
    }
    if (to.params.context) {
      store.commit("searchContext", to.params.context);
    }
    next();
  });

  router.beforeEach(async (to, from, next) => {
    if (to.path === "/signout") {
      clearJwt();
      await apolloClient.resetStore();
      store.commit("user", undefined);
      if (from.meta.requiresAuth) {
        next({ name: "landing" });
      } else {
        next({ path: from.path });
      }
      return;
    }

    if (to.name === "signin" && from.name) {
      store.commit("signinNextRoute", { path: from.path, name: from.name });
    }

    if (!isFirstUserFetch) {
      store.dispatch("fetchUser", to).catch((value) => {
        console.error(value);
      });
      console.log("noblocking userFetch");
    }
    try {
      // If the next page is the error page, we shouldn't bother fetching the
      // user
      const isErrorPage = to.name === "error";
      // If there is no JWT, it doesn't make sense to fetch the user
      const hasJwt = getJwt() !== null;
      if (!isErrorPage && hasJwt && isFirstUserFetch) {
        if (to.meta.requiresAuth) {
          await store.dispatch("fetchUser", to);
        } else {
          store.dispatch("fetchUser", to).catch((value) => {
            console.error(value);
          });
        }
        isFirstUserFetch = false;
      }
    } catch (error) {
      console.error(error);
      store.commit("error/push", {
        type: ErrorType.GRAPHQL_ERROR,
        message: "Unable to fetch user data.",
      });
      next({ name: "error" });
      return;
    }

    const isLoggedin = store.getters.isLoggedin;

    if (to.name === "signin" && isLoggedin) {
      next({ name: "landing" });
      return;
    }

    if (to.name === "confirm-email-uid-token" && isLoggedin) {
      next({ name: "landing" });
      return;
    }

    if (to.meta.requiresAuth !== true || isLoggedin) {
      next();
      return;
    }
    next({ name: "signin" });
  });

  // Force reloading on landing page in production
  router.beforeEach(async (to, from, next) => {
    if (!PRODUCTION_MODE) {
      next();
      return;
    }
    if (to.name === "landing") {
      window.location.href = "/";
      next(false);
      return;
    }
    next();
    return;
  });
}

//<< Temporaty User polling ----------------------------------------------
let userSubscriptionRunning = true;
const userPollingIntervall = 1000;

async function loadUser() {
  try {
    const userRes = await apolloClient.query({
      query: gql`
        query PollUser {
          user {
            email
            username
            balance
          }
        }
      `,
    });

    const userData: any = userRes.data;
    const user = userData && userData.user;
    store.commit("user", user);
  } catch (error) {
    store.commit("user", undefined);
    console.error(error);
  }
}

async function subscribeToUser() {
  if (userSubscriptionRunning) {
    return;
  }
  userSubscriptionRunning = true;
  while (userSubscriptionRunning) {
    await loadUser();
    await sleep(userPollingIntervall);
  }
}

// function unsubscribeToUser() {
//   userSubscriptionRunning = false;
// }

// tslint:disable-next-line
subscribeToUser();
//Temporaty User polling >>
